import { BasicData } from './BasicData';
export default BasicData;